<script lang="ts" setup>
import type { ScaleLinear } from 'd3';
import type { BarChartOptions } from '../index.vue';

// Props
defineProps<{
  loading: boolean;
  yScale: ScaleLinear<number, number>;
  options: BarChartOptions;
  numTicks?: number;
  customTicks?: number[];
}>();

// Refs
const rightYAxisValues = ref<HTMLDivElement[]>([]);
defineExpose({
  rightYAxisValues,
});
</script>
<template>
  <div
    class="relative h-[calc(100%-var(--marginTop)-var(--marginBottom))] w-[var(--marginRight)] translate-y-[var(--marginTop)] overflow-visible"
    style="position: absolute; right: 0; top: 0"
  >
    <div
      v-for="(value, i) in customTicks || yScale.ticks(numTicks || 10)"
      ref="rightYAxisValues"
      :key="i"
      :style="{ top: `${yScale(value)}%` }"
      class="absolute left-0 text-xs tabular-nums -translate-y-1/2 text-gray-400 text-left pl-4"
    >
      <template v-if="!loading">
        <template v-if="options.y2?.unit && i === (customTicks || yScale.ticks(numTicks || 10)).length - 1">
          {{ options.y2.unit }}
        </template>
        <template v-else>
          {{ Math.round(value) }}
        </template>
      </template>
    </div>
  </div>
</template>
